export function getErrorProps(err) {
  const { message, stack, status, cause, constructor, ...customProps } = err;
  return { type: err.constructor.name, message, stack, status, cause, constructor, customProps };
}

export const loggerLevels = { trace: 10, debug: 20, info: 30, warn: 40, error: 50 };
export const loggerMethods = Object.keys(loggerLevels);
export const loggerLevelsUpperCase = loggerMethods.reduce((acc, name) => {
  acc[name] = name.toUpperCase();
  return acc;
}, {});
